let activeFetch = null;

function initCartSalesAssistant() {
  const el = document.querySelector('cart-sales-assistant');
  if (!el) return;

  const salesAssitantFieldId = el.getAttribute('data-cart-attribute');
  if (!salesAssitantFieldId) return;

  const field = document.getElementById(salesAssitantFieldId);
  if (!field) return;

  field.addEventListener('change', async (e) => {
    const target = e.target;
    const salesAssistant = target.value;

    if (activeFetch) {
      activeFetch.abort();
    }
    const abortController = new AbortController();
    activeFetch = abortController;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [target.name]: salesAssistant } }),
        signal: abortController.signal,
      });
    } catch (err) {
      if (err.name === 'AbortError') return;
      console.error('Failed to save cart attribute', err);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartSalesAssistant);
} else {
  initCartSalesAssistant();
}
